export default {"src":"/_next/static/media/keywords.c6c0a5b3.svg","height":288,"width":400};